<div id="{{ id }}-work-item-state" *ngIf="!isRemoteExam && !isGlobalExam">
  <div
    id="{{ id }}-status-indicator"
    [tooltip]="tooltipStateIcon"
    [tooltipData]="state"
    [disableTooltip]="!(item && item.state)"
    position="right"
    delay="700"
    *ngIf="!loading && state && state.ownership && state.activity"
    (click)="toggleAssignmentIfAllowedEvent($event)"
  >
    <svg-icon
      id="{{ id }}-status-indicator-icon"
      [name]="state | workItem: 'state-icon'"
      [applyClass]="true"
      [svgClass]="state | workItem: 'state-class'"
    >
    </svg-icon>
  </div>

  <wfm-spinner *ngIf="loading" size="16"></wfm-spinner>
</div>

<ng-template #tooltipStateIcon let-data="data">
  <div id="{{id}}-status-indicator-tooltip"  class="break-word flex flex--nowrap flex--left flex--baseline flex--col" >
    <div id="unassigned" *ngIf="!(data | workItem: 'isWfmAssigned')">
      {{ 'workloadManager.listContainer.workItem.unassignedLabel' | translate }}
    </div>
    <!-- assignment -->
    <div
      id="assigned"
      *ngIf="data | workItem: 'isWfmAssigned'"
      class="flex flex--row flex--nowrap flex--left flex--middle"
    >
      <div class="u-pr- wf-icon-16 flex__item flex__item--top">
        <svg-icon
          [name]="data | workItem: 'state-icon':'assigned'"
          [svgStyle]="{ fill: 'currentColor', 'width.px': '16', 'height.px': '16' }"
          [applyClass]="true"
          [svgClass]="data | workItem: 'state-class': 'assigned'"
        >
        </svg-icon>
      </div>
      <div>
        <div>
          <span *ngIf="data.extAppWorkItemState !== 'RA1000_Approver_Added'">
            {{ 'workloadManager.listContainer.workItem.assignedLabel' | translate }}
          </span>
          <span *ngIf="data.extAppWorkItemState == 'RA1000_Approver_Added'">
            {{ 'workloadManager.listContainer.workItem.externallyAssignedLabel' | translate }}
          </span>
          <span id="assignee-name">
            {{ data.ownership.assignedToUser[0] | doctorName: userId }}
          </span>
        </div>
        <div>
          <span> {{ 'workloadManager.listContainer.workItem.byLabel' | translate }} </span>
          <span id="assignor-name">
            {{ data.ownership.assignedByUser | doctorName: userId }}
          </span>
        </div>
        <div>
          <span id="assigned-time">{{ data.ownership.assignedOn | epochTimeAgo }}</span>
        </div>
      </div>
    </div>

    <!--Reading block-->
    <div class="flex flex--row flex--nowrap flex--left flex--middle" id="locked-exam" *ngIf="data && data.isActivated">
      <div class="u-pr--- wf-icon-16">
        <svg-icon
          [name]="data | workItem: 'state-icon'"
          [svgStyle]="{ 'fill': 'currentColor', 'width.px': '16', 'height.px': '16' }"
          [applyClass]="true"
          [svgClass]="data | workItem: 'state-class'"
        >
        </svg-icon>
      </div>
      <div class="state-description">
        <span> {{ 'workloadManager.listContainer.workItem.readingByLabel' | translate }} </span>
        <span id="reader-name-span">
          {{ data.activity.readingDto | doctorName: userId }}
        </span>
      </div>
    </div>

    <!-- external user assignment -->
    <div
      id="external-user-assign"
      class="flex flex--row flex--nowrap flex--left flex--middle"
      *ngIf="(data | workItem: 'sort-user-list':[2, 4]) !== false"
    >
      <div class="fas fa-desktop state-indicator externally-opened-offset externally-opened flex__item--top"></div>
      <div class="state-description">
        <span id="externalUserAssignDesc" *ngIf="(data | workItem: 'sort-user-list':[2, 4]) !== false">
          {{ 'assignments.ra1000ExamInfo' | translate }}</span
        >
        <div>
          <span id="external-user-assign-name" *ngFor="let label of data | workItem: 'sort-user-list':[2, 4]">
            {{ label | doctorName: userId }}<br />
          </span>
        </div>
      </div>
    </div>

    <!-- study management assignment -->
    <div
      id="study-management-assign"
      class="flex flex--row flex--nowrap flex--left flex--middle"
      *ngIf="(data | workItem: 'sort-user-list':[6]) !== false"
    >
      <div class="u-pr--- wf-icon-16 flex__item--top">
        <svg-icon
          [name]="data | workItem: 'state-icon'"
          [svgStyle]="{ 'fill': 'currentColor', 'width.px': '16', 'height.px': '16' }"
          [applyClass]="true"
          [svgClass]="data | workItem: 'state-class'"
        >
        </svg-icon>
      </div>
      <div class="">
        <span id="study-manegment-progress-desc" *ngIf="(data | workItem: 'sort-user-list':[6]) !== false">
          {{ 'assignments.studyMgmtInfo' | translate }}
        </span>
        <div>
          <span id="study-manegment-assign-name" *ngFor="let label of data | workItem: 'sort-user-list':[6]">
            {{ label | doctorName: userId }}<br />
          </span>
        </div>
      </div>
    </div>

    <!-- Record management assignment -->
    <div
      id="edit"
      *ngIf="data | workItem: 'isWfmEdit'"
      class="flex flex--row flex--nowrap flex--left flex--middle"
    >
      <div class="u-pr- wf-icon-16 flex__item flex__item--top">
        <svg-icon
          [name]="data | workItem: 'state-icon':'edit'"
          [svgStyle]="{ fill: 'currentColor', 'width.px': '16', 'height.px': '16' }"
          [applyClass]="true"
          [svgClass]="data | workItem: 'state-class'"
        >
        </svg-icon>
      </div>
      <div class="">
        <span id="record-managment-progress-desc">
          {{ 'assignments.recordMgmtInfo' | translate }}
        </span>
        <div>
          <span id="record-manegment-assign-name">
           {{ data.ownership.assignedByUser | doctorName: userId }}
          </span>
        </div>
      </div>
    </div>
  </div>
</ng-template>
